import { render, staticRenderFns } from "./FilesCategories.vue?vue&type=template&id=46d10481"
import script from "./FilesCategories.vue?vue&type=script&lang=ts"
export * from "./FilesCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports